module.exports = __webpack_public_path__ + "img/img2.884a2755.png";